import Swiper from 'swiper';

export default () => {
  const productCarousels = document.querySelectorAll('.js-related-slider-block');
  if (productCarousels) {
    productCarousels.forEach(carousel => {
      let initSlider = new Swiper(carousel, {
        slidesPerView: 1,
        centeredSlides: true,
        longSwipesMs: 1000,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1023: {
            slidesPerView: 3,
          },
        },
      });
  
      enlargeBottom(initSlider, initSlider.activeIndex);
  
      initSlider.on('slideChangeTransitionEnd', function (i) {
        initSlider.slides.forEach(item => {
          let bottom = item.querySelector('.ProductCard__Bottom');
          bottom.style.visibility = 'hidden';
          bottom.style.height = '0px';
        });
        enlargeBottom(initSlider, i.activeIndex);
      });
    });
  }

}

const enlargeBottom = (slider,current) => {
  setTimeout(() => {
    let bottom = slider.slides[current].querySelector('.ProductCard__Bottom');
    bottom.style.visibility = 'visible';
    bottom.style.height = bottom.dataset.height+'px';
  }, 100);
}